import * as React from "react"
import { useAdminTheme } from "../contexts/AdminThemeContext"

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

export function NavSecondary({
  items,
  setActiveTab,
  ...props
}) {
  const { isDarkMode, toggleTheme } = useAdminTheme();
  
  const handleItemClick = (item) => {
    const navigationMap = {
      'Analytics': 'analytics',
      'Settings': 'settings'
    };
    
    const tabKey = navigationMap[item.title];
    if (tabKey && setActiveTab) {
      setActiveTab(tabKey);
    }
  };

  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        {/* Theme Toggle */}
        <div className="px-3 py-2 mb-2">
          <button
            onClick={toggleTheme}
            className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg transition-all duration-200 hover:bg-opacity-10 hover:bg-muted-foreground text-sm font-medium"
            style={{ color: 'var(--color-text)' }}
            aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
          >
            {isDarkMode ? (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
                Light Mode
              </>
            ) : (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.004 9.004 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                </svg>
                Dark Mode
              </>
            )}
          </button>
        </div>
        
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton 
                asChild
                onClick={() => handleItemClick(item)}
              >
                <a href="#" onClick={(e) => e.preventDefault()}>
                  <item.icon />
                  <span>{item.title}</span>
                </a>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
